module.exports = __webpack_public_path__ + "static/media/About-overlay.3786afe5.jpg";